import {defineAsyncComponent} from "vue";

import {NfHotelMainComponentBase} from "@/components/mainComponents/NfHotelMainComponentBase";
import {loadTemplateRenderFunction} from "@/utilities/templateLoader";
import {NfMessageType} from "@/serviceWorker/workerComponents/NfMessage";
import {SetReservationSearchData} from "@/serviceWorker/workerComponents/MessageTypes/SetReservationSearchData";
import {ReservationSearchData} from "@/serviceWorker/workerComponents/Models/ReservationSearchData";
import {NewModalRequest} from "@/serviceWorker/workerComponents/MessageTypes/NewModalRequest";
import {NavigateRequest} from "@/serviceWorker/workerComponents/MessageTypes/NavigateRequest";
import {
    getNavigationNameFromPage,
    getNavigationPageFromName,
    NavigationPageName,
    NavigationPages
} from "@/frontendClasses/NavigationPages";
import {FirstAvailableTermParameters, getFirstAvailableTerm} from "@/services/NfFirstAvailableTermService";
import {Navigated} from "@/serviceWorker/workerComponents/MessageTypes/Navigated";
import type {FindFirstPeriodMode} from "@/frontendClasses/FindFirstPeriodMode";
import type {PageData} from "@/frontendClasses/PageData";
import type {ConfirmationPageData} from "@/frontendClasses/ConfirmationPageData";
import type {InstanceConfiguration} from "@/frontendClasses/InstanceConfiguration";
import {SetInstanceConfiguration} from "@/serviceWorker/workerComponents/MessageTypes/SetInstanceConfiguration";
import {isEmpty} from "lodash-es";
import type {RoomStandardPageData} from "@/frontendClasses";
import type {NfHotelComponentInstance} from "@/components/NfHotelComponentBase";


let renderFunction: Function|null = null;
let defaultTemplateName = 'modal';
const renderFunctionPromise = loadTemplateRenderFunction(defaultTemplateName).then(
    _renderFunction => renderFunction = _renderFunction
);
//region Zaczynamy ładować szablony podkomponentów jak tylko to możliwe
loadTemplateRenderFunction('menu');
//endregion
class NfHotelBookingEngineModal extends NfHotelMainComponentBase   {
    name = 'NfHotelBookingEngineModal';
    defaultTemplateName = defaultTemplateName;
    constructor() {
        super();

        this.requestedGlobalMessageTypes = [
            ...this.requestedGlobalMessageTypes,
            NfMessageType.AvailabilityData, NfMessageType.NewModalRequest, NfMessageType.SetReservationSearchData,
            NfMessageType.NavigateRequest, NfMessageType.SetRoomStandardChosen,
            NfMessageType.CheckBookingPossibleResult];
    }
    setup(props:any, context:any) {
        super.setup(props, context);
        if(window.nfShowDebugMessages) {
            console.debug('setup', arguments);
        }
    }


    props =  {
        widgetId: Number,
        /**
         * Data przyjazdu YYYY-MM-DD
         */
        dateFrom: String,
        /**
         * Data wyjazdu YYYY-MM-DD
         */
        dateTo: String,
        /**
         * Jeśli true, to nie jesteśmy uruchomieni w trybie modala, tylko w trybie sekcji strony
         */
        notInModal: Boolean,
        /**
         * Ilość dorosłych
         */
        adultCount: Number,
        /**
         * Ilość dzieci
         */
        childrenCount: Number,
        /**
         * wiek poszczególnych dzieci
         * @type number[]
         */
        childrenAges: Array,
        /**
         * Idki planów cenowych
         * @type number[]
         */
        offerIds: Array,
        /**
         * Idki standardów pokojów
         * @type number[]
         */
        roomStandardIds: Array,
        /**
         * Idki standardów pokojów które pójdą do oddzielnej listy 'topStandards' na liście standardów i zostaną wykluczone z normalnej listy standardów
         */
        topRoomStandardIds: Array,
        /**
         * Id oferty pobytowej, jeśli BE został uruchomiony dla oferty pobytowej
         */
        chanceId: Number,
        /**
         * Dwu-literowy kod języka
         */
        languageCode: String,
        /**
         * Czy pominąć pokazywanie propozycji innych terminów, gdy wybrany termin będzie pusty
         */
        noPropositions: Boolean,
        findFirstPeriod: String,
        findPacket: Number,
        /**
         * Opcjonalnie można zmienić nazwę tempalatki modala
         */
        templateName: String,
        /**
         * Opcjonalnie można przekazać jakieś properki do szablonu
         */
        templateVarsInit: Object,
        /**
         * Opcjonalnie nazwa pierwszej strony która ma być wyświetlana
         */
        page: String,
        /**
         * Opcjonalnie można przekazać id instancji widgeta, używać tylko przy przeładowaniu bo ten komponent powinien tworzyć własne instancje normalnie
         */
        serviceInstanceId: Number,
        /**
         * Opcjonalnie możliwość automatycznego wyszukiwania gdy są daty i liczba osób
         */
        forceSearch: Boolean,
        /**
         * czy pokazywać kalendarz w formie kafelków.
         */
        simplify: Boolean,
        /**
         * odpowiada za pobranie danych po zmianach w konfiguracji lub przejściu do ofert.
         */
        alwaysSearch: Boolean,
        /**
         * Konfiguracja pokoi
         */
        customRooms: (str: string) => {
            if (isEmpty(str))
                return undefined;
            return JSON.parse(str) as {
                adultCount?: number,
                childrenAges?: number[],
            }[];
        },
    }
    /**
     * Dane w tym miejscu są ładowane w loader.js z urla lub z atrybutów obiektu <nf-booking-engine-window>
     * W atrybutach i urlu te parametry są w snake case
     * Uwaga: jeśli któreś z tych propek mają być przekazywane z urla, to trzeba je dodać do QueryHandler.__fieldsTakenFromUrl w loader.js
     */ //@ts-ignore
    declare $mainProps: {
        widgetId: number,

        /**
         * Data przyjazdu YYYY-MM-DD
         */
        dateFrom?: string,
        /**
         * Data wyjazdu YYYY-MM-DD
         */
        dateTo?: string,
        /**
         * Jeśli true, to jesteśmy w trybie zwykłego contentu strony, a nie w trybie modala
         */
        notInModal: boolean,
        /**
         * Ilość dorosłych
         */
        adultCount?: number,
        /**
         * Ilość dzieci
         */
        childrenCount?: number,
        /**
         * wiek poszczególnych dzieci
         * @type number[]
         */
        childrenAges?: number[],
        /**
         * Idki planów cenowych
         * @type number[]
         */
        offerIds?: number[],
        /**
         * Idki standardów pokojów
         * @type number[]
         */
        roomStandardIds?: number[],
        /**
         * Idki standardów pokojów które pójdą do oddzielnej listy 'topStandards' na liście standardów i zostaną wykluczone z normalnej listy standardów
         */
        topRoomStandardIds?: number[],
        /**
         * Id oferty pobytowej, jeśli BE został uruchomiony dla oferty pobytowej
         */
        chanceId?: number,
        /**
         * Dwu-literowy kod języka
         */
        languageCode?: string,
        /**
         * Czy pominąć pokazywanie propozycji innych terminów, gdy wybrany termin będzie pusty
         */
        noPropositions?: boolean,
        findFirstPeriod?: FindFirstPeriodMode,
        /**
         * Id pakietu dla którego chcemy wyszukać pierwszy dostępny okres (tylko z find-first-period)
         */
        findPacket?: number,
        page?: NavigationPageName,
        forceSearch?:boolean,
        simplify?: boolean,
        alwaysSearch?: boolean,
        customRooms?: {
            adultCount?: number,
            childrenAges?: number[],
        }[],
    };
    beforeCreate() {
        super.beforeCreate();
        super.setRenderFunctionWhenLoaded(renderFunction,renderFunctionPromise);
    }

    data() {
        return {
            ...super.data(),
            instanceConfiguration: this.getInstanceConfiguration()
        }
    }
    components = {
        nfHotelTopMenu: defineAsyncComponent(() =>
            import('../subComponents/NfHotelTopMenu')
        ),
        nfHotelRoomStandardList: defineAsyncComponent(() =>
            import('../subComponents/NfHotelRoomStandardList')),
        nfHotelOfferList: defineAsyncComponent(() =>
            import('../subComponents/NfHotelOfferList')),
        nfHotelPacketList: defineAsyncComponent(() =>
            import('../subComponents/NfHotelPacketList')),
        nfHotelShopPage: defineAsyncComponent(() =>
            import('../subComponents/NfHotelShopPage')),
        nfHotelReservationSummary: defineAsyncComponent(() =>
            import('../subComponents/NfHotelReservationSummary')),
        nfHotelReservationConfirmation: defineAsyncComponent(() =>
            import('../subComponents/NfHotelReservationConfirmation')),
        nfHotelModal: defineAsyncComponent(() =>
            import('../subComponents/NfHotelModal')),
        nfHotelPeopleConfiguration: defineAsyncComponent(() =>
            import('../subComponents/NfHotelPeopleConfiguration')),
        nfHotelPaymentPage:  defineAsyncComponent(() =>
            import('../subComponents/NfHotelPaymentPage')),
        nfHotelGroupReservationBasket: defineAsyncComponent(() =>
            import('../subComponents/NfHotelGroupReservationBasket')),
        nfHotelReservationCheckIn: defineAsyncComponent(() =>
            import('../subComponents/NfHotelReservationCheckIn'))
    }
    sanitizeMainProps() {
        if(!self.moment(this.$mainProps.dateFrom as string,'YYYY-MM-DD').isValid()) {
            this.$mainProps.dateFrom = undefined;
        }
        if(!self.moment(this.$mainProps.dateTo as string,'YYYY-MM-DD').isValid()) {
            this.$mainProps.dateFrom = undefined;
        }
    }
    mounted() {
        this.setDefaultProperties();
        super.mounted();
        this.sanitizeMainProps();
        this.$data.instanceConfiguration = this.getInstanceConfiguration();
        if(!this.$mainProps?.widgetId) {
            throw Error('Brakuje atrybutu widget-id');
        }
        if(!this.communication) {
            throw Error('Brakuje obiektu komunikacji');
        }
        //Inicjalizacja properek
        if (this.$mainProps.page) {
            this.$data.currentPage = this.$mainProps.page;
        }
        this.$data.widgetId = this.$mainProps?.widgetId as number;
    }

    private setDefaultProperties() {
        this.$mainProps.forceSearch = true;
        this.$mainProps.alwaysSearch = true;
    }

    beforeUnmount() {
        super.beforeUnmount();
        if(this.$data.groupReservationService) {
            this.$data.groupReservationBasket = null;
        }
    }
    onMainComponentReady() {
        super.onMainComponentReady();
        if(!this.$data) {
            throw Error('Brakuje danych komponentu');
        }
        if(!this.communication) {
            throw Error('Brakuje obiektu komunikacji');
        }
        this.communication.communicationReadyPromise.then(this.onCommunicationReady)
    }
    onCommunicationReady() {
        if(!this.communication) {
            throw Error('Brakuje obiektu komunikacji');
        }
        this.communication.sendMessage(new SetInstanceConfiguration(this.communication.getComponentId(), this.getInstanceConfiguration() as InstanceConfiguration));
        const searchData = new ReservationSearchData();
        if(this.$mainProps.dateFrom) {
            searchData.dateFrom = self.moment(this.$mainProps.dateFrom as string,'YYYY-MM-DD');
        }
        if(this.$mainProps.dateTo) {
            searchData.dateTo = self.moment(this.$mainProps.dateTo as string,'YYYY-MM-DD');
        }
        if(this.$mainProps.adultCount) {
            searchData.adultCount = Number(this.$mainProps.adultCount);
        }
        if(this.$mainProps.childrenCount) {
            searchData.childrenCount = Number(this.$mainProps.childrenCount);
        }
        if(this.$mainProps.childrenAges && Array.isArray(this.$mainProps.childrenAges)) {
            searchData.childrenAges = this.$mainProps.childrenAges;
        }
        if (!!this.$mainProps.roomStandardIds?.length) {
            searchData.roomStandardIds = [...this.$mainProps.roomStandardIds];
        }
        if (!!this.$mainProps.topRoomStandardIds?.length) {
            searchData.topRoomStandardIds = [...this.$mainProps.topRoomStandardIds];
        }
        if (!!this.$mainProps.chanceId) {
            searchData.chanceId = this.$mainProps.chanceId;
        }
        if (!!this.$mainProps.offerIds?.length) {
            searchData.offerIds = [...this.$mainProps.offerIds];
        }
        if (!!this.$mainProps.customRooms?.length) {
            this.$mainProps.customRooms.forEach(room => {
                const newRoom = searchData.addRoom();
                if(room.adultCount) {
                    newRoom.adultCount = room.adultCount;
                }
                if(room.childrenAges) {
                    newRoom.childrenAges = room.childrenAges;
                }
            });
        }
        (this.communication.getMessageObservable(NfMessageType.SetReservationSearchData).subscribe(message => {
            if(message instanceof SetReservationSearchData) {
                this.onSearchSelectionChanged(message);
            }
        }));
        //region Obsługa nawigacji
        (this.communication.getMessageObservable(NfMessageType.NavigateRequest).subscribe(async message => {
            if(message instanceof NavigateRequest) {
                if(message.navigationPage == NavigationPages.beginningPage) {
                    const firstPageName: NavigationPageName = this.$mainProps.page || 'standards';
                    const firstPageId = getNavigationPageFromName(firstPageName);
                    if(firstPageId) {
                        this.$data.currentPage = firstPageName;
                        message.navigationPage = firstPageId
                    } else {
                        message.navigationPage = NavigationPages.roomStandardSearchPage;
                    }
                } else {
                    this.$data.currentPageData = message.getNavigationData();
                }
                if(message.navigationPage == NavigationPages.shopPage
                    && (this.$data.config?.shop_items_available || '0') != '1') {
                    if (this.$data.groupReservationService?.requestCalculation()) {
                        await this.communication.getNextMessagePromise(NfMessageType.GetReservationCalculationResult);
                    }
                    message.navigationPage = NavigationPages.confirmationPage;
                }
                let newPage = getNavigationNameFromPage(message.navigationPage);
                if(newPage != this.$data.currentPage) {
                    this.closeAllModals();
                    this.$data.currentPage = newPage;
                    this.$data.currentPageData = message.getNavigationData();
                    window.setTimeout(() => {
                        this.communication.sendMessage(new Navigated(message.navigationPage, message.getNavigationData()));
                    })
                }
            }
        }));
        //endregion
        (this.communication.getMessageObservable(NfMessageType.NewModalRequest).subscribe(message => {
            if(message instanceof NewModalRequest) {
                //this.onNewModalRequest(message);
            }
        }));
        if(searchData.dateFrom && searchData.dateTo) {
            this.communication.sendMessage(new SetReservationSearchData(this.communication.getComponentId(),
                searchData));
        } else {
            if(this.$mainProps.findFirstPeriod && this.$mainProps.findFirstPeriod !== 'false') {

                const firstAvailableTermParameters:FirstAvailableTermParameters = {
                };
                if(this.$mainProps.roomStandardIds && this.$mainProps.roomStandardIds.length > 0) {
                    firstAvailableTermParameters.room_standards = this.$mainProps.roomStandardIds;
                }
                let pageDataChanged = false;
                if(this.$mainProps.offerIds && this.$mainProps.offerIds.length > 0) {
                    firstAvailableTermParameters.offers = this.$mainProps.offerIds;
                    if (this.$data.currentPage === 'standards' && this.$mainProps.offerIds.length == 1) {
                        let pageData = this.$data.currentPageData as RoomStandardPageData|null;
                        if (null === pageData) {
                            pageData = {} as RoomStandardPageData;
                            pageData.offerId = firstAvailableTermParameters.offers[0]
                            this.$data.currentPageData = pageData;
                        } else {
                            pageData.offerId = firstAvailableTermParameters.offers[0]
                        }
                        pageDataChanged = true;
                    }
                }
                if(this.$mainProps.adultCount) {
                    firstAvailableTermParameters.adult_count = this.$mainProps.adultCount;
                    if(this.$mainProps.childrenAges) {
                        firstAvailableTermParameters.children_ages = this.$mainProps.childrenAges;
                    }
                }
                if (this.$mainProps.findPacket) {
                    firstAvailableTermParameters.packet_id = this.$mainProps.findPacket;
                    if (this.$data.currentPage === 'standards') {
                        let pageData = this.$data.currentPageData as RoomStandardPageData|null;
                        if (null === pageData) {
                            pageData = {} as RoomStandardPageData;
                            pageData.packetId = firstAvailableTermParameters.packet_id
                            this.$data.currentPageData = pageData;
                        } else {
                            pageData.packetId = firstAvailableTermParameters.packet_id
                        }
                        pageDataChanged = true;
                    }
                }
                getFirstAvailableTerm(this.$mainProps.widgetId, firstAvailableTermParameters).then(
                    firstAvailableTerm => {
                        if(firstAvailableTerm.first_from_date && firstAvailableTerm.first_to_date) {
                            searchData.dateFrom = self.moment(firstAvailableTerm.first_from_date as string,'YYYY-MM-DD');
                            searchData.dateTo = self.moment(firstAvailableTerm.first_to_date as string,'YYYY-MM-DD');
                            this.communication.sendMessage(new SetReservationSearchData(this.communication.getComponentId(),
                                searchData));
                        } else {
                            searchData.dateFrom = null;
                            searchData.dateTo = null;
                            this.communication.sendMessage(new SetReservationSearchData(this.communication.getComponentId(),
                                searchData));
                        }
                    }
                );
                if (pageDataChanged) {
                    this.communication.sendMessage(new NavigateRequest(getNavigationPageFromName(this.$data.currentPage)!, this.$data.currentPageData!));
                }
            } else {
                this.communication.sendMessage(new SetReservationSearchData(this.communication.getComponentId(),
                    searchData));
            }
        }

    }
    public onSearchSelectionChanged(message: SetReservationSearchData) {
        const anythingChanged = this.$data.reservationSearchData.applyNewSearchData(message.getReservationSearchData());
        if(anythingChanged) {
            switch(this.$data.currentPage) {
                case 'confirmation':
                case 'shop':
                    //Gdy jesteśmy na podsumowaniu i tylko kod rabatu się zmienia, to będzie on odrazu aplikowany
                    if(!(anythingChanged.length == 1 && anythingChanged[0] == 'discountCode')) {
                        this.navigate(NavigationPages.beginningPage);
                    }
                    break;
                default:
                    if(message.alreadySearched) {
                        return;
                    }
                    //Gdy zmieni się wyszukiwanie, resetujemy widok z powrotem do widoku ofert
                    this.navigate(NavigationPages.beginningPage);
                    break;
            }
        }
    }
    protected getInstanceConfiguration(): InstanceConfiguration|null {
        if(!this.$mainPropsLoaded) {
            return null;
        }
        return {
            widgetId: this.$mainProps.widgetId,
            dateFrom: this.$mainProps.dateFrom,
            dateTo: this.$mainProps.dateTo,
            notInModal: this.$mainProps.notInModal,
            adultCount: this.$mainProps.adultCount,
            childrenCount: this.$mainProps.childrenCount,
            childrenAges: this.$mainProps.childrenAges,
            offerIds: this.$mainProps.offerIds,
            roomStandardIds: this.$mainProps.roomStandardIds,
            topRoomStandardIds: this.$mainProps.topRoomStandardIds,
            chanceId: this.$mainProps.chanceId,
            languageCode: this.$mainProps.languageCode,
            noPropositions: this.$mainProps.noPropositions,
            findFirstPeriod: this.$mainProps.findFirstPeriod,
            firstPageName: this.$mainProps.page,
            forceSearch: this.$mainProps.forceSearch,
            alwaysSearch: this.$mainProps.alwaysSearch,
            simplify: this.$mainProps.simplify,
        }
    }
    methods: any = {
        destroyBookingEngine(this:NfHotelBookingEngineModal) {
            this.destroy();
        },
        reloadBookingEngine(this:NfHotelBookingEngineModal) {
            this.reload();
        },
        goToNextPage:function(this:NfHotelBookingEngineModal) {
            switch(this.$data.currentPage) {
                case 'shop':
                    let confirmationPageData = this.$data.currentPageData as ConfirmationPageData;
                    if(this.$data.shopChosen) {
                        confirmationPageData.shopChosen = this.$data.shopChosen;
                    }
                    this.navigate(NavigationPages.confirmationPage, confirmationPageData);
                    break;
                case 'confirmation':
                    break;
            }
        },
        goToPreviousPage:function(this:NfHotelComponentInstance<NfHotelBookingEngineModal>) {
            switch(this.$data.currentPage) {
                case 'confirmation':
                    this.navigate(NavigationPages.shopPage, this.$data.currentPageData as PageData);
                    break;
                case 'shop':
                    this.gotoBeginning();
            }

        },
        goToBeginning(this:NfHotelBookingEngineModal) {
            this.navigate(NavigationPages.roomStandardSearchPage, this.$data.currentPageData as PageData);
        },
        goToShop(this:NfHotelBookingEngineModal) {
            this.navigate(NavigationPages.shopPage, this.$data.currentPageData as PageData);
        },
        goToConfirmation(this:NfHotelBookingEngineModal) {

            let confirmationPageData = this.$data.currentPageData as ConfirmationPageData;
            if(this.$data.shopChosen) {
                confirmationPageData.shopChosen = this.$data.shopChosen;
            }
            this.navigate(NavigationPages.confirmationPage, confirmationPageData);
        }
    }

}
const defaultInstance =new NfHotelBookingEngineModal();
export default defaultInstance;
